/*********************************/
/* 定数
/*********************************/
/**
 * オペレータ権限
 */
export class OperatorAuthType {
  /** 一般 */
  static readonly shop: string = "0";
  /** 本部管理者 */
  static readonly shop_admin: string = "1";
  /** 運用管理者 */
  static readonly operator_admin: string = "2";
  /** 運用管理者(兼本部管理者) */
  static readonly operator_shop_admin: string = "3";
  /** コールセンター */
  static readonly call_center: string = "4";
}

/**
 * オペレータ所属グループ
 */
export class OperatorGroup {
  /** 店舗 */
  static readonly shop: string = "0";
  /** 本部 */
  static readonly shop_admin: string = "1";
  /** その他 */
  static readonly other: string = "2";
}

/**
 * 可・不可
 */
export class PossibleType {
  /** 不可 */
  static readonly impossible: string = "0";
  /** 可 */
  static readonly possible: string = "1";
}

/**
 * 配達残数表示の種類
 */
export class DeliverableDisplay {
  /** 数字 */
  static readonly number: string = "0";
  /** 記号 */
  static readonly symbol: string = "1";
  /** 記号の場合の△表示の閾値の下限値 */
  static readonly triangle_min_value: number = 1;
  /** 記号の場合の△表示の閾値の上限値 */
  static readonly triangle_max_value: number = 3;
}

/**
 * 荷札印刷可能フラグ の種類
 */
export class ShippingLabelPrintType {
  /** 印刷しない */
  static readonly impossible: number = 0;
  /** 印刷する */
  static readonly possible: number = 1;
}

/**
 * 配達伝票印刷可能フラグ の種類
 */
export class DeliveryOrderPrintType {
  /** 印刷しない */
  static readonly impossible: number = 0;
  /** 印刷する */
  static readonly possible: number = 1;
}

/**
 * 仮会員登録機能フラグ の種類
 */
export class TmpMemberRegistrationType {
  /** 利用しない */
  static readonly impossible: number = 0;
  /** 利用する */
  static readonly possible: number = 1;
}

/**
 * 在庫移動・回収依頼の配送タイプ
 */
export class DeliveryRequestType {
  /** 在庫移動 */
  static readonly move_type_zaiko: number = 1;
  /** 回収移動 */
  static readonly move_type_kaishu: number = 2;
}

/**
 *  支払金額必須
 */
export class DeliveryRequireMoney {
  /** 任意 */
  static readonly money_norequired: string = "0";
  /** 必須 */
  static readonly money_required: string = "1";
}

/**
 * 配達グループ登録時の新規か既存
 */
export class SelectType {
  /** 新規 */
  static readonly new: string = "0";
  /** 既存 */
  static readonly exist: string = "1";
}

/**
 * 一般的な定数
 */
export class GeneralConstant {
  /** 文言データデフォルト用(チェーン) */
  static readonly word_defalut_chain_key: string = "defalut";
  /** 文言データデフォルト用(カスタマーコード) */
  static readonly word_defalut_customer_key: string = "all";
  /** 非表示 */
  static readonly word_hide: string = "(非表示)";
}

/*********************************/
/* 配列リスト
/*********************************/
/**
 * ログインしているユーザが利用できる所属グループリスト
 * -店舗
 * -本部
 * -その他
 */
export class OperationGroupList {
  /** ログインユーザ[店舗]で利用できる所属グループ */
  static readonly shop: { index: string; item: string }[] = [
    { index: OperatorGroup.shop, item: "店舗" },
  ];

  /** ログインユーザ[本部]で利用できる所属グループ */
  static readonly shop_admin: { index: string; item: string }[] = [
    { index: OperatorGroup.shop, item: "店舗" },
    { index: OperatorGroup.shop_admin, item: "本部" },
  ];

  /** ログインユーザ[その他]で利用できる所属グループ */
  static readonly other: { index: string; item: string }[] = [
    { index: OperatorGroup.shop, item: "店舗" },
    { index: OperatorGroup.shop_admin, item: "本部" },
    { index: OperatorGroup.other, item: "その他" },
  ];
}

/**
 * ログインしているユーザが利用できる権限リスト
 * -一般
 * -本部管理者
 * -運用管理者
 */
export class OperationAuthTypeList {
  /** ログインユーザ[店舗]で利用できる権限 */
  static readonly shop: { index: string; item: string }[] = [
    { index: OperatorAuthType.shop, item: "一般" },
  ];

  /** ログインユーザ[本部]で利用できる権限 */
  static readonly admin: { index: string; item: string }[] = [
    { index: OperatorAuthType.shop_admin, item: "本部管理者" },
  ];

  /** ログインユーザ[その他]で利用できる権限 */
  static readonly other: { index: string; item: string }[] = [
    { index: OperatorAuthType.operator_admin, item: "運用管理者" },
    /*
    {
      index: OperatorAuthType.operator_shop_admin,
      item: "運用管理者(兼本部管理者)",
    },*/
  ];

  /** ログインユーザ全てで利用できる権限 */
  static readonly all: { index: string; item: string }[] = [
    { index: OperatorAuthType.operator_admin, item: "運用管理者" },
    {
      index: OperatorAuthType.operator_shop_admin,
      item: "運用管理者(兼本部管理者)",
    },
    { index: OperatorAuthType.shop_admin, item: "本部管理者" },
    { index: OperatorAuthType.shop, item: "一般" },
  ];
}

/**
 * 選択ボックスorラジオボタンで使用する一般的な名称
 */
export class GeneralTypeList {
  /** 不可or可 */
  static readonly possible: { index: string; item: string }[] = [
    { item: "不可", index: PossibleType.impossible },
    { item: "可", index: PossibleType.possible },
  ];

  /** 配達残数の表示方法 */
  static readonly display_method: { index: string; item: string }[] = [
    { item: "記号(〇△✕)", index: DeliverableDisplay.symbol },
    { item: "数字", index: DeliverableDisplay.number },
  ];

  /** 荷札印刷可能フラグ */
  static readonly displashipping_label_print: {
    index: number;
    item: string;
  }[] = [
    { item: "印刷しない", index: ShippingLabelPrintType.impossible },
    { item: "印刷する", index: ShippingLabelPrintType.possible },
  ];

  /** 配達伝票印刷可能フラグ */
  static readonly display_delivery_order_print: {
    index: number;
    item: string;
  }[] = [
    { item: "印刷しない", index: DeliveryOrderPrintType.impossible },
    { item: "印刷する", index: DeliveryOrderPrintType.possible },
  ];

  /** 仮会員登録機能フラグ */
  static readonly display_tmp_member_registration_flg: {
    index: number;
    item: string;
  }[] = [
    { item: "利用しない", index: TmpMemberRegistrationType.impossible },
    { item: "利用する", index: TmpMemberRegistrationType.possible },
  ];

  /** 曜日リスト（毎週） */
  static readonly holiday: { value: number; label: string }[] = [
    { label: "毎週月曜日", value: 1 },
    { label: "毎週火曜日", value: 2 },
    { label: "毎週水曜日", value: 3 },
    { label: "毎週木曜日", value: 4 },
    { label: "毎週金曜日", value: 5 },
    { label: "毎週土曜日", value: 6 },
    { label: "毎週日曜日", value: 7 },
  ];

  /** 曜日リスト */
  static readonly week: { value: number; label: string }[] = [
    { label: "月", value: 1 },
    { label: "火", value: 2 },
    { label: "水", value: 3 },
    { label: "木", value: 4 },
    { label: "金", value: 5 },
    { label: "土", value: 6 },
    { label: "日", value: 7 },
  ];

  /** 配達グループ登録の新規or既存 */
  static readonly new_or_exist: { index: string; item: string }[] = [
    { item: "新規", index: SelectType.new },
    { item: "既存", index: SelectType.exist },
  ];

  /** キャップ設定 */
  static readonly cap_setting: { index: number; item: string }[] = [
    { item: "全曜日", index: 0 },
    { item: "曜日ごと", index: 1 },
  ];
}

/** 配送依頼・在庫移動 */
export class DeliveryRequest {
  /** 在庫移動 */
  static readonly move_type: { label: string; value: number }[] = [
    { label: "在庫移動", value: DeliveryRequestType.move_type_zaiko },
    { label: "回収移動", value: DeliveryRequestType.move_type_kaishu },
  ];

  /** ステータス */
  static readonly status: { id: string; name: string }[] = [
    {
      id: "5",
      name: "受付済",
    },
    {
      id: "10",
      name: "出荷済",
    },
    {
      id: "20",
      name: "引取前キャンセル",
    },
    {
      id: "30",
      name: "引取後キャンセル",
    },
    {
      id: "40",
      name: "配達完了",
    },
    {
      id: "99",
      name: "受付エラー",
    },
  ];
}

/** 配送ステータス */
export class DeliveryStatusName {}

/**
 * チェーンの登録に使用する名称
 */
export class ChainColumnList {
  /** 会員のハウスカード登録 */
  static readonly house_card_display: { id: number; name: string }[] = [
    { id: 0, name: "登録しない" },
    { id: 1, name: "登録する" },
  ];

  /** ハウスカード必須 */
  static readonly house_card_required: { id: number; name: string }[] = [
    { id: 0, name: "任意" },
    { id: 1, name: "必須" },
  ];

  /** オペレーターのメールアドレス登録 */
  static readonly operator_column_email: { id: number; name: string }[] = [
    { id: 0, name: "登録しない" },
    { id: 1, name: "登録する" },
  ];
}

/**
 * CSVファイルアップロード設定
 */
export class CsvFileUploadSetting {
  static readonly default_csv_split_unit: number = 100; // デフォルトのCSV分割ユニットの定数
}
